import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import TestImageImg from "../../../../../assets/images/joftPooch/pictureTestImg.jpg";
import OrderSection from "./OrderSection";
import { useSelector, useDispatch } from "react-redux";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import CustomHint from "../../../../../assets/containers/CustomHint";

export default function OrderQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion, rightAnswer } = useSelector(({ quiz }) => quiz);
  const [sortedOpts, setSortedOpts] = useState([]);

  useEffect(() => {
    if (currentQuestion) {
      dispatch(
        setQuestionAnswer({
          questionId: currentQuestion._id,
          userOptionsSortingAnswer: sortedOpts,
        })
      );
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [sortedOpts, currentQuestion, dispatch]);

  return (
    <div className="w-100">
      {rightAnswer && (
        <div className="my-5">
          <CustomHint hint={`پاسخ صحیح: ${rightAnswer}`} />
        </div>
      )}
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestImageImg
              : TestImageImg
            : TestImageImg
        }
        noBg={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? true
                : false
              : true
            : false
        }
      />
      {currentQuestion && (
        <OrderSection
          options={currentQuestion.optionsSorting}
          onSort={(items) => setSortedOpts(items)}
        />
      )}
    </div>
  );
}
